import type { ShareUnderPayload } from '~/api/types'
import { money } from '~/sheet/EventSheet'

import { Frame, Wordmark, link } from './Frame'
import { Line, Stop, meta } from './Line'
import { span } from './night'
import s from './Share.module.css'

export type UnderProps = Omit<ShareUnderPayload, 'kind'>

/**
 * Format C: the week's picks under £N, cheapest first, as stops on the week's line with
 * the night of each to its left.
 *
 * The number is the promise, so this is the one card that prints pence — the sheet's
 * formatter, with no range: a list headed "under £15" that said "from £4" would be hedging
 * the one fact it exists to state. The fare sits in acid at the right of each stop, and
 * nothing else on the stop is acid.
 */
export function Under({ host, frame, pounds, first, last, rows }: UnderProps) {
  return (
    <Frame format="C" frame={frame} className={s.under}>
      <div className={s.head}>
        <div className={`${s.kick} ${s.mono}`} data-probe="data">
          This week · {span(first, last)}
        </div>
        <div className={`${s.big} ${s.disp}`} data-probe="display">
          Under <b>£{pounds}</b>
        </div>
      </div>
      <Line labelled>
        {rows.map(row => (
          <Stop key={row.id} day={`${row.dowShort} ${row.dayNum}`}>
            <div className={s.title}>{row.title}</div>
            <span className={`${s.meta} ${s.mono}`}>{meta(row, '')}</span>
            {row.priceMin == null ? null : (
              <span className={`${s.fare} ${s.mono}`}>{money(row.priceMin, null)}</span>
            )}
          </Stop>
        ))}
      </Line>
      <div className={s.foot}>
        <div>
          <div className={`${s.note} ${s.mono}`}>prices as listed, before fees</div>
          <div className={`${s.host} ${s.mono}`}>{link(host)}</div>
        </div>
        <Wordmark />
      </div>
    </Frame>
  )
}
